<template>
    <div>
        <div>
            <el-button size="mini" @click="linkDialog = true">选择链接</el-button>
            <el-button size="mini" type="danger" v-if="link" plain @click="toClear">清空链接</el-button>
        </div>
        <div class="link-box" v-if="link">
            <el-descriptions class="margin-top" title="" :column="1" size="mini" border>
                <el-descriptions-item>
                    <template slot="label">
                        已选择链接：
                    </template>
                    {{link}}
                </el-descriptions-item>
            </el-descriptions>
        </div>

		<el-dialog title="选择链接" :visible.sync="linkDialog" append-to-body width="500px">
            <PageLink @success="linkSuccess"></PageLink>
		</el-dialog>
    </div>
</template>

<script>
import PageLink from './PageLink.vue'
export default {
    props: {
        url: {
            type: String,
            default: ''
        }  
    },
    data(){
        return {
            linkDialog: false,
            link: '',
        }
    },
    watch: {
        url(info){
            this.link = info
        }
    },
    components: {
        PageLink
    },
    methods: {
        linkSuccess(link){
            this.link = link
            this.$emit('success', link)
            this.linkDialog = false
        },
        toClear(){
            this.link = ''
            this.$emit('success', '')
        }
    }
}
</script>

<style lang="scss" scoped>
    .link-box{
        padding-top: 15px;
    }
</style>


// WEBPACK FOOTER //
// src/components/LinkSelect.vue